module.exports = __webpack_public_path__ + "static/img/6.a86ecbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/6.png
// module id = r5/Z
// module chunks = 0